import { render } from "./SelectDispatchTypeModal.vue?vue&type=template&id=fa8c1fa6&scoped=true"
import script from "./SelectDispatchTypeModal.vue?vue&type=script&lang=js"
export * from "./SelectDispatchTypeModal.vue?vue&type=script&lang=js"

import "./SelectDispatchTypeModal.vue?vue&type=style&index=0&id=fa8c1fa6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa8c1fa6"]])

export default __exports__